import { Stack, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";

export default function Breadcrumbs({ title, description }: IBreadcrumbs) {
  const navigate = useNavigate();

  return (
    <Stack spacing={2}>
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        pt={4}
      >
        <Stack direction="row" spacing={2} alignItems="center">
          <Typography
            color="primary.main"
            fontWeight={500}
            fontSize={{
              xs: 24,
              sm: 32,
            }}
          >
            /
            <Typography
              component={"span"}
              color="text.primary"
              fontWeight={500}
              fontSize={{
                xs: 24,
                sm: 32,
              }}
            >
              {title}
            </Typography>
          </Typography>
        </Stack>
        <Typography
          fontWeight={400}
          fontSize={{
            xs: 14,
            sm: 16,
          }}
          //  component={Link}
          // to='/'
          onClick={() => navigate(-1)}
          sx={{
            borderBottom: "2px solid",
            borderColor: "primary.main",
            "&:hover": {
              color: "primary.main",
              cursor: "pointer",
            },
          }}
          color="text.primary"
        >
          {"<"}~~ Back
        </Typography>
      </Stack>
      <Typography
        color="text.secondary"
        fontWeight={400}
        fontSize={{
          xs: 14,
          sm: 16,
        }}
      >
        {description}
      </Typography>
    </Stack>
  );
}
